import { message } from 'antd';
import axiosConfig from '../utils/axiosConfig';
import convertPageToRow from '../utils/convertPageToRow';
import { Channels } from '../components/common/channelsEnum';
import { OtherList } from '../components/common/otherListEnum';
import { Components } from '../components/common/componentsEnum';

export interface URLMap {
  [key: string]: string;
}

export const beeEditorOnSaveHandler = async (
  internalOnSave: string,
  HTMLOnSave: string,
  subject: string | undefined,
  preview: string | undefined,
  addressFrom: string | undefined,
  nameFrom: string | undefined,
  httpURLSelection: URLMap,
  savesRowName: string | undefined,
  channel: Channels | Components | OtherList,
  setSaving: React.Dispatch<React.SetStateAction<boolean>>,
  setChangedSinceSave: React.Dispatch<React.SetStateAction<boolean>>
): Promise<void> => {
  let params;
  if (savesRowName) {
    try {
      const internal = convertPageToRow(
        JSON.parse(internalOnSave),
        savesRowName
      );
      params = {
        internal: internal,
        internalPage: internalOnSave,
        html: HTMLOnSave,
        subject,
        previewText: preview,
        senderName: nameFrom,
        senderEmail: addressFrom
      };
    } catch (e) {
      let msg = 'Unknown Error';
      if (e instanceof Error) msg = e.message;
      message.error(msg, 6);
    }
  } else {
    params = {
      internal: internalOnSave,
      html: HTMLOnSave,
      subject,
      previewText: preview,
      senderName: nameFrom,
      senderEmail: addressFrom
    };
  }
  if (params) {
    await axiosConfig(
      'patch',
      httpURLSelection[channel],
      params,
      undefined,
      (e) => {
        message.error('Something went wrong. Changes are NOT saved.', 6);
      }
    );
  } else {
    message.error('Something went wrong. Changes are NOT saved.', 6);
  }
  setSaving(false);
  setChangedSinceSave(false);
};
